import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Measurement } from './measurement';
export { Measurement };
import { measurementSchema } from '@schemas/business-objects/measurement';
import { MeasurementSetFormGroup } from './measurement-set-form-group';
import { MeasurementTypeFormGroup } from './measurement-type-form-group';

export class MeasurementFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    x1: SchemaFormControl;
    y1: SchemaFormControl;
    x2: SchemaFormControl;
    y2: SchemaFormControl;
    pixelLength: SchemaFormControl;
    scaledLength: SchemaFormControl;
    measurementSetId: SchemaFormControl;
    measurementSet: MeasurementSetFormGroup;
    measurementTypeId: SchemaFormControl;
    measurementType: MeasurementTypeFormGroup;
  };

  declare value: Partial<Measurement>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(measurementSchema, Measurement, data, options);
  }

  get object(): Measurement {
    return new Measurement(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'measurementSet':
        return new MeasurementSetFormGroup();
      case 'measurementType':
        return new MeasurementTypeFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<Measurement[]> {
    return Measurement.find(filter);
  }

  static async findOne(filter?: any): Promise<Measurement | null> {
    return Measurement.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<Measurement> {
    return Measurement.findById(id, filter);
  }

  static async create(data: Partial<Measurement>): Promise<Measurement> {
    return Measurement.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<Measurement>,
  ): Promise<Measurement> {
    return Measurement.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return Measurement.deleteById(id);
  }
}

export class MeasurementFormArray extends PersistedFormArray {
  readonly entityName = 'Measurement' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(measurementSchema, Measurement, options);
  }

  protected override createItemGroup() {
    return new MeasurementFormGroup();
  }

  get array(): Measurement[] {
    return this.controls.map((group: MeasurementFormGroup) => group.object);
  }
}

export class MeasurementPersistedArray extends PersistedArray<Measurement> {
  readonly entityName = 'Measurement' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Measurement, options);
  }
}
